// Mesquite Mafia: 4X Dallas County World Engine & 3D War Table
import { state, log, updateCurrencies } from '../core/state.js';
import { playSFX } from '../core/audio.js';
import { updateMissionProgress } from './missions.js';
import { syncStateToD1, callServerAction } from '../services/api.js';

export let selectedSector = 's1';
export let currentMapZoomPreset = 'overview';
export let isTacticalOverlayVisible = true;

export const sectorData = {
      s1: {
        title: "Sector 1: HomeTown Inn",
        sub: "US-80 Frontage • HQ",
        status: "HOMETOWN DOMINION",
        statusColor: "#ffffff",
        yield: "+150 Cash • +120 Product",
        threat: "Secured / Headquarters",
        marchTarget: { top: "36%", left: "32%" }
      },
      s1_scrap: {
        title: "Sector 1 Outpost: Big Town Salvage",
        sub: "Big Town Blvd • Impound & Scrap",
        status: "CONTROLLED SCRAP FOUNDRY",
        statusColor: "#cbd5e1",
        yield: "+250 Scrap/hr",
        threat: "Cleared (Big Mike Extradited)",
        marchTarget: { top: "42%", left: "18%" }
      },
      s2: {
        title: "Sector 2: Town East Mall",
        sub: "I-635 & Town East Blvd • Highvalue Property",
        status: "CONTESTED BY HECTOR ALVAREZ",
        statusColor: "#ef4444",
        yield: "+1,200 Cash/hr • High Value Tech",
        threat: "Retail Booster Ring Active",
        marchTarget: { top: "30%", left: "68%" }
      },
      s3: {
        title: "Sector 3: Mesquite Rodeo Arena",
        sub: "Rodeo Drive • Industrial",
        status: "HELD BY BEAU 'THE BULL'",
        statusColor: "#94a3b8",
        yield: "+450 Arms/hr • Permanent Rally Ground",
        threat: "Fortified Troops",
        marchTarget: { top: "55%", left: "74%" }
      },
      s4: {
        title: "Sector 4: Mesquite City Hall",
        sub: "1515 N. Galloway Ave • Government Zone",
        status: "MUNICIPAL MONOPOLY (DIRECTOR VANCE)",
        statusColor: "#ffffff",
        yield: "Citywide Protection Tax (5% Server Gathering)",
        threat: "Police Dispatch Armed",
        marchTarget: { top: "65%", left: "49%" }
      }
    };

export let warTable = {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      raycaster: null,
      mouse: null,
      interactiveObjects: [],
      selectionRing: null,
      policeCruiser: null,
      policeStrobeLights: null,
      supplyTruck: null,
      roadblocks: { us80: null, i635: null },
      camTargetPos: null,
      camLookTarget: null,
      initialized: false
    };

export function selectSector(key) {
      const isAlt = state.territories[key] && state.territories[key].owner !== 'player';
      playSFX(isAlt ? 'city_select_alt' : 'city_select');
      activeSectorKey = key;
      const d = sectorData[key];
      if (!d) return;
      document.getElementById('sidebar-title').innerText = d.title;
      document.getElementById('sidebar-sub').innerText = d.sub;
      document.getElementById('sidebar-status').innerText = d.status;
      document.getElementById('sidebar-status').style.color = d.statusColor;
      document.getElementById('sidebar-yield').innerText = d.yield;
      document.getElementById('sidebar-threat').innerText = d.threat;
      updateMapNodes();

      const reqLv = key === 's2' ? 2 : key === 's3' ? 3 : key === 's4' ? 4 : 1;
      const isLocked = (state.compoundLevel || 1) < reqLv;
      const marchBtn = document.getElementById('dispatch-march-btn');

      let t = state.territories[key];
      if(t) {
        if (isLocked) {
          document.getElementById('sidebar-status').innerText = `🔒 LOCKED (REQUIRES COMPOUND LV. ${reqLv})`;
          document.getElementById('sidebar-status').style.color = '#ef4444';
          if (marchBtn) {
            marchBtn.innerText = `🔒 LOCKED (UPGRADE HQ TO LV. ${reqLv})`;
            marchBtn.style.background = '#334155';
            marchBtn.style.opacity = '0.7';
          }
        } else {
          let color = t.owner === 'player' ? 'var(--accent-purple)' : (t.owner==='hector'?'var(--accent-blue)':(t.owner==='beau'?'var(--accent-orange)':'var(--accent-gold)'));
          document.getElementById('sidebar-status').innerText = `Control: ${t.control}%`;
          document.getElementById('sidebar-status').style.color = color;
          if (marchBtn) {
            marchBtn.innerText = `🚗 SEND HIT SQUAD`;
            marchBtn.style.background = '';
            marchBtn.style.opacity = '1';
          }
        }
        document.getElementById('sidebar-yield').innerText = `Income: ${JSON.stringify(t.income).replace(/\"/g, '')} | Troops: ${t.troops} | Def: ${t.defenseLevel || 2}`;
        
        const garr = document.getElementById('sidebar-garrison');
        if (garr) garr.innerText = `${t.troops} Troops (Def Lv. ${t.defenseLevel || 2})`;
        
        const supply = document.getElementById('sidebar-supply');
        if (supply) {
          const corridor = (key === 's2' || key === 's3') ? 'I-635 Highway Corridor' : 'US-80 Frontage Road';
          supply.innerText = state.roadblocks[key === 's2' || key === 's3' ? 'i635' : 'us80'] ? `Fortified (${corridor})` : `Active (${corridor})`;
        }
        
        const threat = document.getElementById('sidebar-threat');
        if (threat) {
          const rKey = key === 's1_scrap' ? 'mike' : key === 's2' ? 'hector' : key === 's3' ? 'beau' : key === 's4' ? 'vance' : null;
          if (rKey && state.rivalThreats && state.rivalThreats[rKey]) {
            threat.innerText = `${state.rivalThreats[rKey].threat}% Hostile Threat (${state.rivalThreats[rKey].archetype.toUpperCase()})`;
            threat.style.color = state.rivalThreats[rKey].threat > 60 ? '#ef4444' : '#f59e0b';
          } else {
            threat.innerText = "Secured / Under HQ Dominion";
            threat.style.color = "#4ade80";
          }
        }
      }
      if (typeof update3DSelectionHighlight === 'function') {
        update3DSelectionHighlight(key);
      }
    }

export function updateMapNodes() {
      for(let key in state.territories) {
        let t = state.territories[key];
        let node = document.getElementById('node-' + key);
        if(!node) continue;
        let ring = node.querySelector('.node-pin-ring');
        let pin = node.querySelector('.node-pin');
        let troops = document.getElementById('troops-' + key);
        
        let color = 'var(--bg-panel)';
        if(t.owner === 'player') color = 'var(--accent-purple)';
        if(t.owner === 'hector') color = 'var(--accent-blue)';
        if(t.owner === 'beau') color = 'var(--accent-orange)';
        if(t.owner === 'vance') color = 'var(--accent-gold)';
        
        ring.style.background = `conic-gradient(${color} ${t.control}%, transparent 0%)`;
        pin.style.borderColor = color;
        if(troops) troops.innerText = t.troops + ' Troops';
      }
    }

export function reinforceSector() {
      if(state.product >= 100) {
        state.product -= 100;
        let t = state.territories[activeSectorKey];
        if(t) {
           t.troops += 5;
           t.control = Math.min(100, t.control + 5);
           if(t.control === 100) t.owner = 'player';
        }
        SFX.cash();
        updateCurrencies();
        updateMapNodes();
        selectSector(activeSectorKey);
        playActionSequence({
          title: "SECTOR REINFORCED",
          icon: "🛡️",
          detail: `Supplied extra muscle to ${sectorData[activeSectorKey].title}`,
          rewardText: "+5 Troops • +5% Regional Dominion",
          shots: 1
        });
      } else {
        playActionSequence({
          title: "SHORT SUPPLY",
          icon: "❌",
          detail: "Need at least 100 Product to mobilize reinforcements.",
          rewardText: "Replenish in The Cookshack",
          shots: 0
        });
      }
    }

export function dispatchMarch() {
      const d = sectorData[activeSectorKey];
      const reqLv = activeSectorKey === 's2' ? 2 : activeSectorKey === 's3' ? 3 : activeSectorKey === 's4' ? 4 : 1;
      if ((state.compoundLevel || 1) < reqLv) {
        playSFX('gunshot');
        playActionSequence({
          title: "SECTOR RESTRICTED / AIRSPACE LOCKED",
          icon: "🔒",
          detail: `Sector ${activeSectorKey.toUpperCase()} requires Compound Level ${reqLv} to breach!`,
          rewardText: "Upgrade Room 114 Operations Center in Compound tab",
          shots: 0
        });
        return;
      }

      playSFX('march_dispatch');
      const convoy = document.getElementById('march-convoy');
      convoy.style.display = 'flex';
      convoy.style.top = '36%';
      convoy.style.left = '32%';
      document.getElementById('march-text').innerText = `Slidin' On ${d.title.split(':')[1] || d.title}`;

      const sessionToken = localStorage.getItem("mesquite_session_token");
      if (sessionToken) {
        try {
          fetch('/api/world', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionToken },
            body: JSON.stringify({
              sourceNode: 's1_room114',
              targetNode: activeSectorKey,
              marchType: 'raid',
              troops: { Bruisers: 25, Hitmen: 15, Bikers: 10, Mortars: 2 },
              travelSeconds: 3
            })
          }).catch(() => {});
        } catch(e) {}
      }

      setTimeout(() => {
        convoy.style.top = d.marchTarget.top;
        convoy.style.left = d.marchTarget.left;
      }, 50);

      setTimeout(() => {
        convoy.style.display = 'none';
        updateMissionProgress('daily', 'march', 1);
        let t = state.territories[activeSectorKey];
        if(t) t.control = Math.min(100, t.control + 20);
        if(t.control === 100) t.owner = 'player';
        selectSector(activeSectorKey);

        if (activeSectorKey === 's1_scrap') {
          state.scrap += 80;
          state.cash += 150;
          playActionSequence({
            title: "SCRAPYARD LICK",
            icon: "⚙️",
            detail: "Stripped Big Town Salvage flatbed yards!",
            rewardText: "+80 Scrap & Hardware • +$150 Cash",
            shots: 2,
            onComplete: () => { SFX.cash(); log("[OUTPOST]: Recovered 80 salvage scrap."); }
          });
          updateMissionProgress('march_s1_scrap', 1);
        } else if (activeSectorKey === 's2') {
          state.cash += 1200;
          playActionSequence({
            title: "I-635 CORRIDOR HIT",
            icon: "💵",
            detail: "Shook down Town East retail corridor!",
            rewardText: "+$1,200 Dirty Cash Secured",
            shots: 3,
            onComplete: () => { SFX.cash(); log("[RAID]: Town East cash stained."); }
          });
          updateMissionProgress('march_s2', 1);
        } else if (activeSectorKey === 's3') {
          updateMissionProgress('march_s3', 1);
          playActionSequence({
            title: "RODEO AMBUSH",
            icon: "🐂",
            detail: "Heavy exchange in the rodeo pens against Beau's crew!",
            rewardText: "ENTERING ARENA",
            shots: 4,
            onComplete: () => { switchTab('arena'); selectBoss('beau'); }
          });
        } else if (activeSectorKey === 's4') {
          updateMissionProgress('march_s4', 1);
          playActionSequence({
            title: "CITY HALL BREACH",
            icon: "🏛️",
            detail: "Federal units and patrol fleet pinned down!",
            rewardText: "DIRECTOR VANCE CONFRONTED",
            shots: 5,
            onComplete: () => { switchTab('arena'); selectBoss('vance'); }
          });
        } else {
          playActionSequence({
            title: "COMPOUND PATROL",
            icon: "🏨",
            detail: "Sweeped US-80 frontage perimeter. Perimeter tight.",
            rewardText: "Dominion Solidified",
            shots: 1
          });
        }
        
        addXP(100);
        updateCurrencies();
        syncStateToD1();
      }, 3100);
    }

export function toggleWorldMapView(view) {
      playSFX('tab_switch');
      const viewLive = document.getElementById('world-live-view');
      const viewWire = document.getElementById('world-3d-wireframe-view');
      const btnLive = document.getElementById('btn-view-live');
      const btnWire = document.getElementById('btn-view-wire');

      if (view === 'wire') {
        if (viewLive) viewLive.style.display = 'none';
        if (viewWire) viewWire.style.display = 'block';
        if (btnLive) btnLive.classList.remove('active');
        if (btnWire) btnWire.classList.add('active');
        if (!warTable.initialized) {
          init3DWarTable();
        }
        requestAnimationFrame(() => {
          if (typeof resize3DWarTable === 'function') resize3DWarTable();
        });
        log("[TACTICAL MAP]: Switched to 3D Wire Grid radar view.");
      } else {
        if (viewLive) viewLive.style.display = 'block';
        if (viewWire) viewWire.style.display = 'none';
        if (btnLive) btnLive.classList.add('active');
        if (btnWire) btnWire.classList.remove('active');
        log("[TACTICAL MAP]: Switched to Live Action Illustrated Map.");
      }
    }

export function setMapZoomPreset(preset) {
      playSFX('click');
      const conf = mapPresets[preset] || mapPresets.overview;
      currentMapZoomPreset = preset;
      currentZoomScale = conf.scale;
      currentPanX = conf.x;
      currentPanY = conf.y;

      const stage = document.getElementById('live-map-stage');
      if (stage) {
        stage.style.transition = 'transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1)';
        stage.style.transform = `scale(${conf.scale}) translate(${conf.x}%, ${conf.y}%) rotateX(${conf.rotX}deg)`;
      }

      // Update HUD preset buttons active state
      document.querySelectorAll('.war-table-hud-top .war-hud-btn').forEach(b => {
        if (b.id && b.id.startsWith('btn-cam-')) b.classList.remove('active');
      });
      const activeBtn = document.getElementById('btn-cam-' + preset);
      if (activeBtn) activeBtn.classList.add('active');

      if (preset !== 'overview') {
        selectSector(preset);
      }

      log(`[TACTICAL MAP]: Camera zoomed into ${conf.title} (${Math.round(conf.scale * 100)}% Zoom).`);
    }

export function zoomMapStep(delta) {
      playSFX('click');
      currentZoomScale = Math.min(2.8, Math.max(0.85, currentZoomScale + delta));
      const stage = document.getElementById('live-map-stage');
      if (stage) {
        const rot = currentZoomScale > 1.2 ? 12 : 0;
        stage.style.transition = 'transform 0.3s ease-out';
        stage.style.transform = `scale(${currentZoomScale}) translate(${currentPanX}%, ${currentPanY}%) rotateX(${rot}deg)`;
      }
    }

export function focusSectorOnMap(key) {
      document.querySelectorAll('.map-node').forEach(n => n.classList.remove('selected-territory'));
      const pin = document.getElementById('node-' + key);
      if (pin) pin.classList.add('selected-territory');

      setMapZoomPreset(key);
    }

export function initLiveMapInteractions() {
      const viewport = document.getElementById('live-map-viewport');
      const stage = document.getElementById('live-map-stage');
      if (!viewport || !stage) return;

      viewport.addEventListener('mousedown', (e) => {
        if (e.target.closest('button') || e.target.closest('.map-node') || e.target.closest('.tactical-glass-overlay')) return;
        isMapDragging = true;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        viewport.style.cursor = 'grabbing';
      });

      window.addEventListener('mousemove', (e) => {
        if (!isMapDragging) return;
        const dx = (e.clientX - dragStartX) * 0.12;
        const dy = (e.clientY - dragStartY) * 0.12;
        currentPanX += dx;
        currentPanY += dy;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        const rot = currentZoomScale > 1.2 ? 12 : 0;
        stage.style.transition = 'none';
        stage.style.transform = `scale(${currentZoomScale}) translate(${currentPanX}%, ${currentPanY}%) rotateX(${rot}deg)`;
      });

      window.addEventListener('mouseup', () => {
        if (isMapDragging) {
          isMapDragging = false;
          if (viewport) viewport.style.cursor = 'default';
          if (stage) stage.style.transition = 'transform 0.65s cubic-bezier(0.2, 0.8, 0.2, 1)';
        }
      });

      viewport.addEventListener('wheel', (e) => {
        e.preventDefault();
        const delta = e.deltaY < 0 ? 0.18 : -0.18;
        zoomMapStep(delta);
      }, { passive: false });
    }

export function updateLiveMapVehicles() {
      const t = Date.now() * 0.0006;
      
      // Hero Buick GN: Patrols US-80 frontage road
      const hero = document.getElementById('car-hero');
      if (hero) {
        const heroX = 32 + Math.sin(t * 0.8) * 12;
        const heroY = 36 + Math.sin(t * 1.6) * 3;
        hero.style.left = heroX + '%';
        hero.style.top = heroY + '%';
      }

      // Mesquite PD Cruiser: Roams I-635 highway
      const police = document.getElementById('car-police');
      if (police) {
        const pdY = 48 + Math.cos(t * 0.6) * 18;
        const pdX = 56 + Math.sin(t * 0.6) * 5;
        police.style.left = pdX + '%';
        police.style.top = pdY + '%';
      }

      // Hector's Escalade: Patrols Town East
      const hector = document.getElementById('car-hector');
      if (hector) {
        const hX = 66 + Math.sin(t * 0.5) * 6;
        const hY = 30 + Math.cos(t * 0.5) * 5;
        hector.style.left = hX + '%';
        hector.style.top = hY + '%';
      }

      // Beau's Bikers: Roams Arena loop
      const biker = document.getElementById('car-biker');
      if (biker) {
        const bX = 73 + Math.cos(t * 1.1) * 7;
        const bY = 56 + Math.sin(t * 1.1) * 6;
        biker.style.left = bX + '%';
        biker.style.top = bY + '%';
      }

      // Roadblocks display
      const rb80 = document.getElementById('roadblock-us80');
      if (rb80) rb80.style.display = state.roadblocks.us80 ? 'flex' : 'none';
      const rb635 = document.getElementById('roadblock-i635');
      if (rb635) rb635.style.display = state.roadblocks.i635 ? 'flex' : 'none';
    }

export function update4XTelemetry() {
      // Police Heat stars
      const heat = Math.min(5, Math.max(0, state.policeHeat || 0));
      const stars = '⭐'.repeat(heat) + '☆'.repeat(5 - heat);
      const heatEl = document.getElementById('police-heat-stars');
      if (heatEl) {
        heatEl.innerText = stars;
        heatEl.style.color = heat >= 4 ? '#ef4444' : heat >= 2 ? '#f59e0b' : '#22c55e';
      }

      // Convoy ticker
      const activeCount = (state.convoys || []).filter(c => c.active).length;
      const convoyEl = document.getElementById('convoy-status-txt');
      if (convoyEl) {
        convoyEl.innerText = `${activeCount} In Transit (${state.roadblocks.us80 ? 'US-80 Fortified' : 'US-80 Clear'})`;
        convoyEl.style.color = activeCount > 0 ? '#4ade80' : '#94a3b8';
      }

      // Threat radar summary
      const tRadar = document.getElementById('threat-radar-summary');
      if (tRadar && state.rivalThreats) {
        tRadar.innerText = `⚠️ THREAT: Hector ${state.rivalThreats.hector.threat}% • Beau ${state.rivalThreats.beau.threat}% • Vance ${state.rivalThreats.vance.threat}%`;
      }
    }

export function dispatchSupplyConvoy() {
      const cost = 250;
      if (state.cash < cost) {
        playActionSequence({
          title: "INSUFFICIENT FUNDS",
          icon: "❌",
          detail: `Need $${cost.toLocaleString()} cash to fuel and arm a supply convoy.`,
          rewardText: "Collect revenue from sectors or launder cash",
          shots: 0
        });
        return;
      }

      state.cash -= cost;
      playSFX('cash');
      playSFX('march');
      updateCurrencies();

      const targets = ['s1_scrap'];
      if ((state.compoundLevel || 1) >= 2) targets.push('s2');
      const target = targets[Math.floor(Math.random() * targets.length)];
      const cargoType = target === 's1_scrap' ? 'scrap' : 'cash';
      const cargoVal = cargoType === 'scrap' ? 120 : 650;

      state.convoys.push({
        id: 'c_' + Date.now(),
        from: 's1',
        to: target,
        type: cargoType,
        value: cargoVal,
        progress: 0.05,
        speed: 0.0035,
        active: true
      });

      updateMissionProgress('convoy', 1);
      update4XTelemetry();
      syncStateToD1();
      log(`[SUPPLY RUN]: Dispatched armored transport along US-80 to ${sectorData[target].title} ($${cargoVal.toLocaleString()} cargo value).`);

      playActionSequence({
        title: "CONVOY DISPATCHED",
        icon: "📦",
        detail: `Armored supply runner rolling down US-80 corridor!`,
        rewardText: `Expected Yield: +${cargoType === 'cash' ? '$' : ''}${cargoVal.toLocaleString()} ${cargoType.toUpperCase()}`,
        shots: 1
      });

      if (state.policeHeat >= 2 && Math.random() < 0.40) {
        setTimeout(() => {
          triggerHighwayPursuit(false);
        }, 1800);
      }
    }

export function deployRoadblock() {
      const cost = 150;
      if (state.scrap < cost) {
        playActionSequence({
          title: "SCRAP DEFICIT",
          icon: "❌",
          detail: "Need at least 150 Scrap to construct steel barricades & spike strips.",
          rewardText: "Raid Big Town Salvage",
          shots: 0
        });
        return;
      }

      state.scrap -= cost;
      playSFX('vault');
      const road = (activeSectorKey === 's2' || activeSectorKey === 's3') ? 'i635' : 'us80';
      state.roadblocks[road] = true;
      
      let t = state.territories[activeSectorKey];
      if (t) {
        t.defenseLevel = (t.defenseLevel || 2) + 2;
        t.troops += 10;
      }

      updateCurrencies();
      update4XTelemetry();
      if (typeof update3DRoadblocks === 'function') update3DRoadblocks();
      if (activeSectorKey) selectSector(activeSectorKey);

      log(`[DEFENSE]: Fortified ${road.toUpperCase()} with spike strips and armored barricades! Sector defense boosted.`);
      playActionSequence({
        title: "ROADBLOCK FORTIFIED",
        icon: "🚧",
        detail: `${road.toUpperCase()} locked down with heavy scrap barricades!`,
        rewardText: "+10 Garrison Troops • +2 Def Level",
        shots: 1
      });
    }

export function sendDecoyRunner() {
      const cost = 2500;
      if (state.cash < cost) {
        playActionSequence({
          title: "DIRTY CASH REQUIRED",
          icon: "❌",
          detail: "Need $2,500 cash to hire a bait car and driver.",
          rewardText: "Launder cash in motel",
          shots: 0
        });
        return;
      }

      state.cash -= cost;
      playSFX('cash');
      state.policeHeat = Math.max(0, (state.policeHeat || 1) - 1);
      updateCurrencies();
      update4XTelemetry();

      const baitCars = ["'98 Camaro", "Tinted Crown Vic", "Stolen Hellcat", "Flatbed Dually"];
      const baitCar = baitCars[Math.floor(Math.random() * baitCars.length)];
      const scannerEl = document.getElementById('scanner-text');
      if (scannerEl) scannerEl.innerText = `MESQUITE PD: All units respond! High-speed ${baitCar} fleeing northbound on I-635!`;
      log(`[DECOY]: Dispatched ${baitCar} burner car. Diverted police heat (-1 Star).`);

      playActionSequence({
        title: "DECOY CAR BURNING",
        icon: "💨",
        detail: `Mesquite PD patrol cruisers drawn away to I-635!`,
        rewardText: "POLICE HEAT REDUCED (-1 STAR)",
        shots: 2
      });
    }

export function toggleTacticalOverlay() {
      const panel3d = document.getElementById('tactical-overlay-panel');
      const panel2d = document.getElementById('tactical-overlay-panel-2d');
      const btn = document.getElementById('btn-toggle-intel-overlay');
      
      isTacticalOverlayVisible = !isTacticalOverlayVisible;
      
      if (panel3d) {
        panel3d.classList.toggle('hidden', !isTacticalOverlayVisible);
      }
      if (panel2d) {
        panel2d.classList.toggle('hidden', !isTacticalOverlayVisible);
      }
      if (btn) {
        btn.classList.toggle('active', isTacticalOverlayVisible);
        if (isTacticalOverlayVisible) {
          btn.style.background = 'rgba(147, 51, 234, 0.25)';
          btn.style.borderColor = 'var(--accent-purple)';
          btn.style.color = '#e9d5ff';
        } else {
          btn.style.background = 'rgba(30, 41, 59, 0.6)';
          btn.style.borderColor = '#475569';
          btn.style.color = '#94a3b8';
        }
      }
      playSFX('click');
      log(`[TACTICAL HUD]: Command overlay ${isTacticalOverlayVisible ? 'shown' : 'minimized'} (Hotkey: M).`);
    }

export function toggleOverlayTransparency() {
      const panel3d = document.getElementById('tactical-overlay-panel');
      const panel2d = document.getElementById('tactical-overlay-panel-2d');
      const btn = document.getElementById('btn-toggle-transparency');
      
      isTacticalOverlayGhost = !isTacticalOverlayGhost;
      
      if (panel3d) {
        panel3d.classList.toggle('ghost-mode', isTacticalOverlayGhost);
      }
      if (panel2d) {
        panel2d.classList.toggle('ghost-mode', isTacticalOverlayGhost);
      }
      if (btn) {
        btn.classList.toggle('active', isTacticalOverlayGhost);
        if (isTacticalOverlayGhost) {
          btn.style.background = 'rgba(14, 165, 233, 0.3)';
          btn.style.borderColor = '#38bdf8';
          btn.style.color = '#38bdf8';
        } else {
          btn.style.background = 'rgba(30, 41, 59, 0.6)';
          btn.style.borderColor = '#475569';
          btn.style.color = '#94a3b8';
        }
      }
      playSFX('click');
      log(`[TACTICAL HUD]: Ghost translucency mode ${isTacticalOverlayGhost ? 'enabled' : 'disabled'}.`);
    }

export function triggerRandomWorldEvent() {
      const event = worldEventTemplates[Math.floor(Math.random() * worldEventTemplates.length)];
      if (event.effect) {
        event.effect();
        updateCurrencies();
      }
      if (event.sound && typeof SFX[event.sound] === 'function') {
        SFX[event.sound]();
      }
      log(`[WORLD EVENT]: ${event.text}`);
      
      const container = document.getElementById('event-toast-container');
      if (!container) return;
      
      const toast = document.createElement('div');
      toast.className = `event-toast ${event.type}`;
      
      const icon = document.createElement('div');
      icon.className = 'event-icon';
      icon.innerText = event.type === 'positive' ? '📈' : '⚠️';
      
      const textContainer = document.createElement('div');
      const title = document.createElement('div');
      title.style.fontWeight = '800';
      title.style.marginBottom = '4px';
      title.style.color = event.type === 'positive' ? '#4ade80' : '#f87171';
      title.innerText = event.type === 'positive' ? 'SYNDICATE UPDATE' : 'CRITICAL ALERT';
      
      const desc = document.createElement('div');
      desc.innerText = event.text;
      
      textContainer.appendChild(title);
      textContainer.appendChild(desc);
      toast.appendChild(icon);
      toast.appendChild(textContainer);
      container.appendChild(toast);
      
      setTimeout(() => {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 6500);
      
      const nextInterval = 15000 + Math.random() * 30000;
      setTimeout(triggerRandomWorldEvent, nextInterval);
    }

export function init3DWarTable() {
      if (warTable.initialized) return;
      if (typeof THREE === 'undefined') {
        console.warn("Three.js not loaded. Operating in 2D satellite fallback mode.");
        return;
      }

      const canvas = document.getElementById('war-table-canvas');
      const wrapper = document.querySelector('.war-table-3d-wrapper');
      if (!canvas || !wrapper) return;

      const width = wrapper.clientWidth || 800;
      const height = wrapper.clientHeight || 640;

      // 1. Scene setup: Deep Black Void & White Light UnderGlow
      const scene = new THREE.Scene();
      scene.background = new THREE.Color(0x000000); // Deep Black Void
      scene.fog = new THREE.FogExp2(0x000000, 0.0012);
      warTable.scene = scene;

      // 2. Camera setup
      const camera = new THREE.PerspectiveCamera(42, width / height, 1, 3000);
      camera.position.set(0, 310, 360);
      warTable.camera = camera;
      warTable.camTargetPos = camera.position.clone();
      warTable.camLookTarget = new THREE.Vector3(0, 0, 20);

      // 3. Renderer setup
      const renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: false, powerPreference: "high-performance" });
      renderer.setSize(width, height, false);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      warTable.renderer = renderer;

      // 4. OrbitControls
      const OrbitControlsConstructor = THREE.OrbitControls || window.OrbitControls;
      if (OrbitControlsConstructor) {
        const controls = new OrbitControlsConstructor(camera, renderer.domElement);
        controls.enableDamping = true;
        controls.dampingFactor = 0.05;
        controls.maxPolarAngle = Math.PI / 2.15; // Prevent viewing underneath table
        controls.minDistance = 80;
        controls.maxDistance = 850;
        controls.target.copy(warTable.camLookTarget);
        warTable.controls = controls;
      }

      // 5. White Light Specular Table Lighting
      const ambientLight = new THREE.AmbientLight(0xffffff, 1.1);
      scene.add(ambientLight);

      const deskLamp = new THREE.SpotLight(0xffffff, 3.2, 1400, Math.PI / 3.2, 0.35, 1.2);
      deskLamp.position.set(40, 380, 100);
      deskLamp.target.position.set(0, 0, 20);
      deskLamp.castShadow = true;
      deskLamp.shadow.mapSize.width = 1024;
      deskLamp.shadow.mapSize.height = 1024;
      scene.add(deskLamp);
      scene.add(deskLamp.target);

      const coolRimLight = new THREE.DirectionalLight(0xffffff, 1.1);
      coolRimLight.position.set(-240, 180, -200);
      scene.add(coolRimLight);

      // Table Board (Pitch Black Obsidian Carbon Slab)
      const tableGeo = new THREE.BoxGeometry(720, 8, 540);
      const tableMat = new THREE.MeshStandardMaterial({ color: 0x010204, roughness: 0.95, metalness: 0.1 });
      const tableMesh = new THREE.Mesh(tableGeo, tableMat);
      tableMesh.position.set(0, -4, 20);
      tableMesh.receiveShadow = true;
      scene.add(tableMesh);

      // Razor White Light / Silver Specular Edge Border Trim
      const borderGeo = new THREE.BoxGeometry(726, 9, 546);
      const borderMat = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.15, metalness: 0.95, emissive: 0x333333 });
      const borderMesh = new THREE.Mesh(borderGeo, borderMat);
      borderMesh.position.set(0, -4.5, 20);
      scene.add(borderMesh);

      // Luminous White Light & Silver Tactical Wireframe Grid
      const grid = new THREE.GridHelper(740, 37, 0xffffff, 0x94a3b8);
      grid.position.set(0, 1.2, 20);
      grid.material.transparent = true;
      grid.material.opacity = 0.95;
      scene.add(grid);

      // Holographic Radar Rings for Tactical Perimeter
      for (let r = 80; r <= 360; r += 70) {
        const ringGeo = new THREE.RingGeometry(r - 0.8, r + 0.8, 64);
        const ringMat = new THREE.MeshBasicMaterial({ color: 0xffffff, side: THREE.DoubleSide, transparent: true, opacity: 0.35 });
        const ringMesh = new THREE.Mesh(ringGeo, ringMat);
        ringMesh.rotation.x = -Math.PI / 2;
        ringMesh.position.set(0, 1.5, 20);
        scene.add(ringMesh);
      }

      // 6. Monochromatic Noir Materials definition (Black, Silver, White Light)
      const matAsphalt = new THREE.MeshStandardMaterial({ color: 0x090c13, roughness: 0.95 });
      const matYellowLine = new THREE.MeshBasicMaterial({ color: 0xffffff });
      const matWhiteLine = new THREE.MeshBasicMaterial({ color: 0xcbd5e1 });
      const matConcrete = new THREE.MeshStandardMaterial({ color: 0x94a3b8, roughness: 0.65, metalness: 0.3 });
      const matGuardrail = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.2, metalness: 0.85 });
      const matStucco = new THREE.MeshStandardMaterial({ color: 0x334155, roughness: 0.85 });
      const matTrim = new THREE.MeshStandardMaterial({ color: 0x0f172a, roughness: 0.8 });
      const matRoof = new THREE.MeshStandardMaterial({ color: 0x1e293b, roughness: 0.5, metalness: 0.7 });
      const matWindowGlow = new THREE.MeshBasicMaterial({ color: 0xffffff });
      const matBrick = new THREE.MeshStandardMaterial({ color: 0x1e293b, roughness: 0.9 });
      const matLimestone = new THREE.MeshStandardMaterial({ color: 0xf1f5f9, roughness: 0.8 });
      const matBrassToken = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: 0.15, metalness: 0.95 });
      const matGlassPyramid = new THREE.MeshStandardMaterial({ color: 0xffffff, transparent: true, opacity: 0.45, roughness: 0.05, metalness: 0.85 });

      // 7. HIGHWAY SYSTEM (US-80 East-West & I-635 North-South)
      // US-80 Roadway (z = 20)
      const us80 = new THREE.Mesh(new THREE.BoxGeometry(700, 1.2, 28), matAsphalt);
      us80.position.set(0, 0.6, 20);
      us80.receiveShadow = true;
      scene.add(us80);

      const us80Yellow = new THREE.Mesh(new THREE.BoxGeometry(700, 0.1, 0.8), matYellowLine);
      us80Yellow.position.set(0, 1.25, 20);
      scene.add(us80Yellow);

      const us80WhiteL = new THREE.Mesh(new THREE.BoxGeometry(700, 0.1, 0.4), matWhiteLine);
      us80WhiteL.position.set(0, 1.25, 31.5);
      scene.add(us80WhiteL);
      const us80WhiteR = new THREE.Mesh(new THREE.BoxGeometry(700, 0.1, 0.4), matWhiteLine);
      us80WhiteR.position.set(0, 1.25, 8.5);
      scene.add(us80WhiteR);

      // I-635 (LBJ Freeway) with elevated bridge overpass at (80, y, 20)
      const i635S = new THREE.Mesh(new THREE.BoxGeometry(30, 1.2, 180), matAsphalt);
      i635S.position.set(80, 0.6, 170);
      i635S.receiveShadow = true;
      scene.add(i635S);

      const i635N = new THREE.Mesh(new THREE.BoxGeometry(30, 1.2, 170), matAsphalt);
      i635N.position.set(80, 0.6, -145);
      i635N.receiveShadow = true;
      scene.add(i635N);

      // Elevated bridge deck over US-80
      const bridgeDeck = new THREE.Mesh(new THREE.BoxGeometry(30, 2.5, 80), matConcrete);
      bridgeDeck.position.set(80, 16, 20);
      bridgeDeck.castShadow = true;
      bridgeDeck.receiveShadow = true;
      scene.add(bridgeDeck);

      const bridgeRoad = new THREE.Mesh(new THREE.BoxGeometry(28, 0.2, 80), matAsphalt);
      bridgeRoad.position.set(80, 17.3, 20);
      scene.add(bridgeRoad);

      const guardrailL = new THREE.Mesh(new THREE.BoxGeometry(1, 2.5, 80), matGuardrail);
      guardrailL.position.set(65.5, 18.5, 20);
      scene.add(guardrailL);
      const guardrailR = new THREE.Mesh(new THREE.BoxGeometry(1, 2.5, 80), matGuardrail);
      guardrailR.position.set(94.5, 18.5, 20);
      scene.add(guardrailR);

      const pier1 = new THREE.Mesh(new THREE.CylinderGeometry(2.5, 2.5, 16, 16), matConcrete);
      pier1.position.set(80, 8, 3.5);
      pier1.castShadow = true;
      scene.add(pier1);
      const pier2 = new THREE.Mesh(new THREE.CylinderGeometry(2.5, 2.5, 16, 16), matConcrete);
      pier2.position.set(80, 8, 36.5);
      pier2.castShadow = true;
      scene.add(pier2);

      const rampS = new THREE.Mesh(new THREE.BoxGeometry(30, 1.5, 50), matConcrete);
      rampS.position.set(80, 8.5, 75);
      rampS.rotation.x = -0.32;
      scene.add(rampS);

      const rampN = new THREE.Mesh(new THREE.BoxGeometry(30, 1.5, 50), matConcrete);
      rampN.position.set(80, 8.5, -35);
      rampN.rotation.x = 0.32;
      scene.add(rampN);

      // Overhead highway gantry sign
      const gantryPillar1 = new THREE.Mesh(new THREE.CylinderGeometry(0.8, 0.8, 22), matGuardrail);
      gantryPillar1.position.set(-30, 11, 6);
      scene.add(gantryPillar1);
      const gantryPillar2 = new THREE.Mesh(new THREE.CylinderGeometry(0.8, 0.8, 22), matGuardrail);
      gantryPillar2.position.set(-30, 11, 34);
      scene.add(gantryPillar2);
      const gantryBeam = new THREE.Mesh(new THREE.BoxGeometry(1.2, 1.2, 30), matGuardrail);
      gantryBeam.position.set(-30, 21, 20);
      scene.add(gantryBeam);
      const gantrySign = new THREE.Mesh(new THREE.BoxGeometry(1, 6, 18), new THREE.MeshStandardMaterial({ color: 0x065f46 }));
      gantrySign.position.set(-30, 21, 20);
      scene.add(gantrySign);

      // Roadblock meshes (toggleable)
      const roadblockUS80 = new THREE.Group();
      const bar1 = new THREE.Mesh(new THREE.BoxGeometry(4, 5, 24), new THREE.MeshStandardMaterial({ color: 0xd97706, roughness: 0.5 }));
      bar1.position.set(0, 2.5, 20);
      roadblockUS80.add(bar1);
      roadblockUS80.visible = !!state.roadblocks.us80;
      scene.add(roadblockUS80);
      warTable.roadblocks.us80 = roadblockUS80;

      const roadblockI635 = new THREE.Group();
      const bar2 = new THREE.Mesh(new THREE.BoxGeometry(26, 5, 4), new THREE.MeshStandardMaterial({ color: 0xd97706, roughness: 0.5 }));
      bar2.position.set(80, 2.5, -30);
      roadblockI635.add(bar2);
      roadblockI635.visible = !!state.roadblocks.i635;
      scene.add(roadblockI635);
      warTable.roadblocks.i635 = roadblockI635;

      // 8. ARCHITECTURAL MINIATURES (5 LOCATIONS)
      function createSectorBaseRing(x, z, radius, colorHex) {
        const ringGeo = new THREE.RingGeometry(radius - 2, radius + 2, 32);
        const ringMat = new THREE.MeshBasicMaterial({ color: colorHex, side: THREE.DoubleSide });
        const ringMesh = new THREE.Mesh(ringGeo, ringMat);
        ringMesh.rotation.x = -Math.PI / 2;
        ringMesh.position.set(x, 0.4, z);
        scene.add(ringMesh);
        return ringMesh;
      }

      function createTacticalToken(x, z, label, crestColor) {
        const group = new THREE.Group();
        group.position.set(x, 0, z);
        
        const base = new THREE.Mesh(new THREE.CylinderGeometry(8, 8.5, 3.5, 24), matBrassToken);
        base.position.y = 1.75;
        base.castShadow = true;
        group.add(base);

        const coin = new THREE.Mesh(new THREE.CylinderGeometry(6.5, 6.5, 1, 24), new THREE.MeshStandardMaterial({ color: crestColor, roughness: 0.4, metalness: 0.7 }));
        coin.position.y = 3.6;
        group.add(coin);

        scene.add(group);
        return group;
      }

      // --- LOCATION 1: Room 114 HQ (HomeTown Inn) at (-80, 0, 20) ---
      const hqGroup = new THREE.Group();
      hqGroup.position.set(-80, 0, 20);
      hqGroup.userData = { sectorKey: 's1' };

      const hqPad = new THREE.Mesh(new THREE.BoxGeometry(65, 1.8, 60), matConcrete);
      hqPad.position.y = 0.9;
      hqPad.receiveShadow = true;
      hqGroup.add(hqPad);

      const hqWingA = new THREE.Mesh(new THREE.BoxGeometry(45, 18, 20), matStucco);
      hqWingA.position.set(0, 10, -8);
      hqWingA.castShadow = true;
      hqWingA.receiveShadow = true;
      hqGroup.add(hqWingA);

      const hqWingB = new THREE.Mesh(new THREE.BoxGeometry(20, 18, 30), matStucco);
      hqWingB.position.set(20, 10, 15);
      hqWingB.castShadow = true;
      hqWingB.receiveShadow = true;
      hqGroup.add(hqWingB);

      const hqBalcony = new THREE.Mesh(new THREE.BoxGeometry(45, 1.5, 5), matTrim);
      hqBalcony.position.set(0, 10, 3);
      hqGroup.add(hqBalcony);

      for (let i = -16; i <= 16; i += 10) {
        const winLower = new THREE.Mesh(new THREE.BoxGeometry(4.5, 4, 0.4), matWindowGlow);
        winLower.position.set(i, 5, 2.2);
        hqGroup.add(winLower);

        const winUpper = new THREE.Mesh(new THREE.BoxGeometry(4.5, 4, 0.4), matWindowGlow);
        winUpper.position.set(i, 14, 2.2);
        hqGroup.add(winUpper);
      }

      const carportRoof = new THREE.Mesh(new THREE.BoxGeometry(22, 1.5, 18), matRoof);
      carportRoof.position.set(-18, 8.5, 15);
      carportRoof.castShadow = true;
      hqGroup.add(carportRoof);

      const carPost1 = new THREE.Mesh(new THREE.CylinderGeometry(0.5, 0.5, 8.5), matTrim);
      carPost1.position.set(-27, 4.25, 22);
      hqGroup.add(carPost1);

      const buickBody = new THREE.Mesh(new THREE.BoxGeometry(11, 3.2, 5.5), new THREE.MeshStandardMaterial({ color: 0x0a0c10, roughness: 0.2, metalness: 0.8 }));
      buickBody.position.set(-18, 2.6, 15);
      buickBody.castShadow = true;
      hqGroup.add(buickBody);

      const buickCab = new THREE.Mesh(new THREE.BoxGeometry(6, 2.2, 4.8), new THREE.MeshStandardMaterial({ color: 0x05070a, roughness: 0.1 }));
      buickCab.position.set(-18.5, 4.8, 15);
      hqGroup.add(buickCab);

      const hvac1 = new THREE.Mesh(new THREE.BoxGeometry(4, 3, 4), matRoof);
      hvac1.position.set(-10, 20, -8);
      hqGroup.add(hvac1);

      createTacticalToken(-80 - 24, 20 - 20, "Room 114", 0x9333ea);
      createSectorBaseRing(-80, 20, 36, 0x9333ea);

      scene.add(hqGroup);
      warTable.interactiveObjects.push(hqGroup);

      // --- LOCATION 2: Big Town Salvage at (-220, 0, 60) ---
      const salvageGroup = new THREE.Group();
      salvageGroup.position.set(-220, 0, 60);
      salvageGroup.userData = { sectorKey: 's1_scrap' };

      const scrapPad = new THREE.Mesh(new THREE.BoxGeometry(75, 1.5, 65), new THREE.MeshStandardMaterial({ color: 0x2e2924, roughness: 0.95 }));
      scrapPad.position.y = 0.75;
      salvageGroup.add(scrapPad);

      const warehouse = new THREE.Mesh(new THREE.BoxGeometry(44, 22, 34), new THREE.MeshStandardMaterial({ color: 0x475569, roughness: 0.6, metalness: 0.6 }));
      warehouse.position.set(-10, 11.5, 0);
      warehouse.castShadow = true;
      warehouse.receiveShadow = true;
      salvageGroup.add(warehouse);

      const roofPeak = new THREE.Mesh(new THREE.ConeGeometry(24, 8, 4), new THREE.MeshStandardMaterial({ color: 0x7c2d12, roughness: 0.8 }));
      roofPeak.position.set(-10, 25.5, 0);
      roofPeak.rotation.y = Math.PI / 4;
      roofPeak.scale.set(1.4, 1, 1.1);
      salvageGroup.add(roofPeak);

      const baleColors = [0x52525b, 0x78350f, 0x1e3a8a, 0x713f12];
      for (let bx = 0; bx < 3; bx++) {
        for (let bz = 0; bz < 2; bz++) {
          const bale = new THREE.Mesh(new THREE.BoxGeometry(7, 4.5, 7), new THREE.MeshStandardMaterial({ color: baleColors[(bx + bz) % 4], roughness: 0.9 }));
          bale.position.set(18 + bx * 4, 3 + (bx % 2) * 4, -14 + bz * 9);
          bale.castShadow = true;
          salvageGroup.add(bale);
        }
      }

      const towCab = new THREE.Mesh(new THREE.BoxGeometry(9, 6, 6), new THREE.MeshStandardMaterial({ color: 0xd97706, roughness: 0.5 }));
      towCab.position.set(20, 4, 16);
      salvageGroup.add(towCab);

      const towBoom = new THREE.Mesh(new THREE.BoxGeometry(14, 1.4, 1.4), new THREE.MeshStandardMaterial({ color: 0x1e293b, metalness: 0.8 }));
      towBoom.position.set(14, 9, 16);
      towBoom.rotation.z = -0.45;
      salvageGroup.add(towBoom);

      createTacticalToken(-220 + 26, 60 - 20, "Big Mike", 0x7c2d12);
      createSectorBaseRing(-220, 60, 36, 0x9333ea);

      scene.add(salvageGroup);
      warTable.interactiveObjects.push(salvageGroup);

      // --- LOCATION 3: Town East Mall at (180, 0, -100) ---
      const mallGroup = new THREE.Group();
      mallGroup.position.set(180, 0, -100);
      mallGroup.userData = { sectorKey: 's2' };

      const mallPad = new THREE.Mesh(new THREE.BoxGeometry(95, 1.8, 80), matConcrete);
      mallPad.position.y = 0.9;
      mallGroup.add(mallPad);

      const mallMain = new THREE.Mesh(new THREE.BoxGeometry(75, 20, 56), matBrick);
      mallMain.position.set(-5, 11, 0);
      mallMain.castShadow = true;
      mallMain.receiveShadow = true;
      mallGroup.add(mallMain);

      const mallCoping = new THREE.Mesh(new THREE.BoxGeometry(77, 1.5, 58), matLimestone);
      mallCoping.position.set(-5, 21.2, 0);
      mallGroup.add(mallCoping);

      const glassPyramid = new THREE.Mesh(new THREE.ConeGeometry(14, 9, 4), matGlassPyramid);
      glassPyramid.position.set(-5, 25.5, 0);
      glassPyramid.rotation.y = Math.PI / 4;
      mallGroup.add(glassPyramid);

      const garage = new THREE.Mesh(new THREE.BoxGeometry(32, 14, 28), matConcrete);
      garage.position.set(30, 8, 20);
      garage.castShadow = true;
      mallGroup.add(garage);

      createTacticalToken(180 - 36, -100 - 24, "Hector", 0x0284c7);
      createSectorBaseRing(180, -100, 42, 0x0284c7);

      scene.add(mallGroup);
      warTable.interactiveObjects.push(mallGroup);

      // --- LOCATION 4: Mesquite Arena at (210, 0, 110) ---
      const arenaGroup = new THREE.Group();
      arenaGroup.position.set(210, 0, 110);
      arenaGroup.userData = { sectorKey: 's3' };

      const arenaPad = new THREE.Mesh(new THREE.BoxGeometry(85, 1.5, 80), new THREE.MeshStandardMaterial({ color: 0x452a18, roughness: 0.95 }));
      arenaPad.position.y = 0.75;
      arenaGroup.add(arenaPad);

      const arenaColosseum = new THREE.Mesh(new THREE.CylinderGeometry(34, 36, 18, 32), matLimestone);
      arenaColosseum.position.set(0, 10, 0);
      arenaColosseum.castShadow = true;
      arenaColosseum.receiveShadow = true;
      arenaGroup.add(arenaColosseum);

      const domeRoof = new THREE.Mesh(new THREE.SphereGeometry(34, 24, 12, 0, Math.PI * 2, 0, Math.PI / 3), matRoof);
      domeRoof.position.set(0, 13, 0);
      domeRoof.scale.set(1, 0.45, 1);
      arenaGroup.add(domeRoof);

      const corral = new THREE.Mesh(new THREE.TorusGeometry(26, 0.8, 6, 24), new THREE.MeshStandardMaterial({ color: 0x5c3210 }));
      corral.rotation.x = Math.PI / 2;
      corral.position.set(0, 1.8, 0);
      arenaGroup.add(corral);

      const flagpole = new THREE.Mesh(new THREE.CylinderGeometry(0.4, 0.4, 28), matGuardrail);
      flagpole.position.set(32, 14, 28);
      arenaGroup.add(flagpole);

      const flag = new THREE.Mesh(new THREE.BoxGeometry(6, 4, 0.2), new THREE.MeshStandardMaterial({ color: 0x1e3a8a }));
      flag.position.set(35, 25, 28);
      arenaGroup.add(flag);

      createTacticalToken(210 - 28, 110 - 28, "Beau", 0xea580c);
      createSectorBaseRing(210, 110, 38, 0xea580c);

      scene.add(arenaGroup);
      warTable.interactiveObjects.push(arenaGroup);

      // --- LOCATION 5: City Hall (Municipal Seat) at (30, 0, 150) ---
      const hallGroup = new THREE.Group();
      hallGroup.position.set(30, 0, 150);
      hallGroup.userData = { sectorKey: 's4' };

      const terrace = new THREE.Mesh(new THREE.BoxGeometry(75, 2.5, 60), matLimestone);
      terrace.position.y = 1.25;
      hallGroup.add(terrace);

      const hallMain = new THREE.Mesh(new THREE.BoxGeometry(56, 22, 38), matLimestone);
      hallMain.position.set(0, 12, 0);
      hallMain.castShadow = true;
      hallMain.receiveShadow = true;
      hallGroup.add(hallMain);

      for (let col = -20; col <= 20; col += 8) {
        const pillar = new THREE.Mesh(new THREE.CylinderGeometry(1.2, 1.2, 19, 12), matLimestone);
        pillar.position.set(col, 11, 21);
        hallGroup.add(pillar);
      }

      const pediment = new THREE.Mesh(new THREE.ConeGeometry(24, 7, 4), matLimestone);
      pediment.position.set(0, 24, 21);
      pediment.rotation.y = Math.PI / 4;
      pediment.scale.set(1.1, 1, 0.3);
      hallGroup.add(pediment);

      const rotunda = new THREE.Mesh(new THREE.CylinderGeometry(9, 9, 15, 20), matLimestone);
      rotunda.position.set(0, 28, 0);
      rotunda.castShadow = true;
      hallGroup.add(rotunda);

      const copperDome = new THREE.Mesh(new THREE.SphereGeometry(9, 16, 12, 0, Math.PI * 2, 0, Math.PI / 2), new THREE.MeshStandardMaterial({ color: 0x2d4a43, roughness: 0.5, metalness: 0.7 }));
      copperDome.position.set(0, 35.5, 0);
      hallGroup.add(copperDome);

      const clockFace = new THREE.Mesh(new THREE.CircleGeometry(3, 16), matWindowGlow);
      clockFace.position.set(0, 28, 9.1);
      hallGroup.add(clockFace);

      createTacticalToken(30 + 32, 150 - 24, "Vance", 0xd97706);
      createSectorBaseRing(30, 150, 38, 0xd97706);

      scene.add(hallGroup);
      warTable.interactiveObjects.push(hallGroup);

      // 9. ACTIVE SELECTION HIGHLIGHT RING
      const selRingGeo = new THREE.RingGeometry(38, 41, 32);
      const selRingMat = new THREE.MeshBasicMaterial({ color: 0xf59e0b, side: THREE.DoubleSide });
      const selRing = new THREE.Mesh(selRingGeo, selRingMat);
      selRing.rotation.x = -Math.PI / 2;
      selRing.position.set(-80, 0.6, 20);
      scene.add(selRing);
      warTable.selectionRing = selRing;

      // 10. MOVING PATROL VEHICLE & SUPPLY CONVOYS
      const cruiser = new THREE.Group();
      const cBody = new THREE.Mesh(new THREE.BoxGeometry(10, 3.2, 5.2), new THREE.MeshStandardMaterial({ color: 0x0f172a, roughness: 0.3 }));
      cruiser.add(cBody);

      const cDoorL = new THREE.Mesh(new THREE.BoxGeometry(4, 2, 0.1), new THREE.MeshStandardMaterial({ color: 0xf8fafc }));
      cDoorL.position.set(0, 0.2, 2.65);
      cruiser.add(cDoorL);
      const cDoorR = new THREE.Mesh(new THREE.BoxGeometry(4, 2, 0.1), new THREE.MeshStandardMaterial({ color: 0xf8fafc }));
      cDoorR.position.set(0, 0.2, -2.65);
      cruiser.add(cDoorR);

      const redStrobe = new THREE.Mesh(new THREE.BoxGeometry(1.5, 0.8, 1.8), new THREE.MeshBasicMaterial({ color: 0xef4444 }));
      redStrobe.position.set(0, 2.2, 1);
      cruiser.add(redStrobe);
      const blueStrobe = new THREE.Mesh(new THREE.BoxGeometry(1.5, 0.8, 1.8), new THREE.MeshBasicMaterial({ color: 0x3b82f6 }));
      blueStrobe.position.set(0, 2.2, -1);
      cruiser.add(blueStrobe);

      cruiser.position.set(80, 2.5, 0);
      scene.add(cruiser);
      warTable.policeCruiser = cruiser;
      warTable.policeStrobeLights = { red: redStrobe, blue: blueStrobe };

      const supplyTruck = new THREE.Group();
      const truckCab = new THREE.Mesh(new THREE.BoxGeometry(6, 4.5, 5), new THREE.MeshStandardMaterial({ color: 0x1e293b, roughness: 0.5 }));
      truckCab.position.x = 4.5;
      supplyTruck.add(truckCab);

      const truckBox = new THREE.Mesh(new THREE.BoxGeometry(10, 6, 5.2), new THREE.MeshStandardMaterial({ color: 0xd97706, metalness: 0.6, roughness: 0.4 }));
      truckBox.position.set(-3.5, 0.7, 0);
      supplyTruck.add(truckBox);

      supplyTruck.position.set(-80, 2.5, 20);
      scene.add(supplyTruck);
      warTable.supplyTruck = supplyTruck;

      // 11. Raycasting and Interaction Setup
      warTable.raycaster = new THREE.Raycaster();
      warTable.mouse = new THREE.Vector2();

      canvas.addEventListener('pointermove', onWarTablePointerMove);
      canvas.addEventListener('click', onWarTableClick);
      window.addEventListener('resize', resize3DWarTable);
      if (typeof ResizeObserver !== 'undefined' && wrapper) {
        try {
          const ro = new ResizeObserver(() => {
            resize3DWarTable();
          });
          ro.observe(wrapper);
        } catch (e) {}
      }

      warTable.initialized = true;

      // 12. Animation Loop
      let clock = 0;
      function animate() {
        requestAnimationFrame(animate);
        clock += 0.02;

        if (warTable.controls) warTable.controls.update();

        if (warTable.camTargetPos && warTable.camera) {
          warTable.camera.position.lerp(warTable.camTargetPos, 0.06);
          if (warTable.controls && warTable.camLookTarget) {
            warTable.controls.target.lerp(warTable.camLookTarget, 0.06);
          }
        }

        if (warTable.selectionRing) {
          warTable.selectionRing.rotation.z += 0.01;
          const s = 1 + Math.sin(clock * 3) * 0.04;
          warTable.selectionRing.scale.set(s, s, 1);
        }

        if (warTable.policeCruiser) {
          const zPos = Math.sin(clock * 0.4) * 180;
          warTable.policeCruiser.position.z = zPos;
          warTable.policeCruiser.position.y = (zPos > -60 && zPos < 80) ? 17.5 : 2.5;
          warTable.policeCruiser.rotation.y = (Math.cos(clock * 0.4) > 0) ? Math.PI / 2 : -Math.PI / 2;

          const strobe = Math.sin(clock * 14) > 0;
          if (warTable.policeStrobeLights) {
            warTable.policeStrobeLights.red.material.color.setHex(strobe ? 0xff0000 : 0x330000);
            warTable.policeStrobeLights.blue.material.color.setHex(strobe ? 0x002244 : 0x0088ff);
          }
        }

        if (warTable.supplyTruck) {
          const c = (state.convoys && state.convoys[0]) ? state.convoys[0] : null;
          if (c && c.active) {
            warTable.supplyTruck.visible = true;
            const startX = -80;
            const targetX = c.to === 's1_scrap' ? -220 : 180;
            warTable.supplyTruck.position.x = startX + (targetX - startX) * c.progress;
            warTable.supplyTruck.position.z = 20;
            warTable.supplyTruck.rotation.y = targetX > startX ? 0 : Math.PI;
          } else {
            warTable.supplyTruck.visible = false;
          }
        }

        warTable.renderer.render(warTable.scene, warTable.camera);
      }
      animate();
    }

export function resize3DWarTable() {
      if (!warTable.renderer || !warTable.camera) return;
      const wrapper = document.querySelector('.war-table-3d-wrapper');
      if (!wrapper) return;
      const w = wrapper.clientWidth || 800;
      const h = wrapper.clientHeight || 640;
      if (w > 0 && h > 0) {
        warTable.camera.aspect = w / h;
        warTable.camera.updateProjectionMatrix();
        warTable.renderer.setSize(w, h, false);
      }
    }

export function onWarTablePointerMove(event) {
      if (!warTable.raycaster || !warTable.camera) return;
      const rect = event.target.getBoundingClientRect();
      warTable.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      warTable.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      warTable.raycaster.setFromCamera(warTable.mouse, warTable.camera);
      const intersects = warTable.raycaster.intersectObjects(warTable.interactiveObjects, true);

      const tooltip = document.getElementById('war-table-tooltip');
      const canvas = document.getElementById('war-table-canvas');

      if (intersects.length > 0) {
        let root = intersects[0].object;
        while (root.parent && !root.userData?.sectorKey) {
          root = root.parent;
        }

        const key = root.userData?.sectorKey;
        if (key && sectorData[key] && state.territories[key]) {
          if (canvas) canvas.style.cursor = 'pointer';
          const d = sectorData[key];
          const t = state.territories[key];
          const ownerColor = t.owner === 'player' ? '#c084fc' : t.owner === 'hector' ? '#38bdf8' : t.owner === 'beau' ? '#fb923c' : '#facc15';

          if (tooltip) {
            tooltip.style.display = 'block';
            tooltip.style.left = (event.clientX - rect.left + 15) + 'px';
            tooltip.style.top = (event.clientY - rect.top + 15) + 'px';
            tooltip.innerHTML = `
              <div style="font-weight:900; font-size:0.88rem; color:var(--accent-gold); margin-bottom:2px;">${d.title}</div>
              <div style="font-size:0.74rem; color:#94a3b8; margin-bottom:6px;">${d.sub}</div>
              <div style="font-size:0.74rem; display:flex; justify-content:space-between; gap:12px; margin-bottom:4px;">
                <span>Dominion: <strong style="color:${ownerColor};">${t.control}%</strong></span>
                <span>Garrison: <strong style="color:#60a5fa;">${t.troops}</strong></span>
              </div>
              <div style="font-size:0.72rem; color:#86efac;">Output: ${d.yield}</div>
              <div style="font-size:0.72rem; color:#f87171; margin-top:2px;">Threat: ${d.threat}</div>
            `;
          }
          return;
        }
      }

      if (canvas) canvas.style.cursor = 'grab';
      if (tooltip) tooltip.style.display = 'none';
    }

export function onWarTableClick(event) {
      if (!warTable.raycaster || !warTable.camera) return;
      const rect = event.target.getBoundingClientRect();
      warTable.mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      warTable.mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

      warTable.raycaster.setFromCamera(warTable.mouse, warTable.camera);
      const intersects = warTable.raycaster.intersectObjects(warTable.interactiveObjects, true);

      if (intersects.length > 0) {
        let root = intersects[0].object;
        while (root.parent && !root.userData?.sectorKey) {
          root = root.parent;
        }

        const key = root.userData?.sectorKey;
        if (key) {
          selectSector(key);
        }
      }
    }

export function update3DSelectionHighlight(key) {
      if (!warTable.selectionRing) return;
      const coords = {
        s1: { x: -80, z: 20 },
        s1_scrap: { x: -220, z: 60 },
        s2: { x: 180, z: -100 },
        s3: { x: 210, z: 110 },
        s4: { x: 30, z: 150 }
      };

      const c = coords[key] || coords.s1;
      warTable.selectionRing.position.set(c.x, 0.8, c.z);
    }

export function update3DRoadblocks() {
      if (warTable.roadblocks.us80) {
        warTable.roadblocks.us80.visible = !!state.roadblocks.us80;
      }
      if (warTable.roadblocks.i635) {
        warTable.roadblocks.i635.visible = !!state.roadblocks.i635;
      }
    }

export function set3DCameraPreset(preset) {
      playSFX('click');
      if (!warTable.camera) return;

      if (preset === 'hq') {
        warTable.camTargetPos = new THREE.Vector3(-80, 75, 115);
        warTable.camLookTarget = new THREE.Vector3(-80, 10, 20);
        log("[TACTICAL CAMERA]: Focused on Room 114 Headquarters.");
      } else if (preset === 'overview') {
        warTable.camTargetPos = new THREE.Vector3(0, 310, 360);
        warTable.camLookTarget = new THREE.Vector3(0, 0, 20);
        log("[TACTICAL CAMERA]: Overview isometric perspective.");
      } else if (preset === 'top') {
        warTable.camTargetPos = new THREE.Vector3(0, 480, 30);
        warTable.camLookTarget = new THREE.Vector3(0, 0, 20);
        log("[TACTICAL CAMERA]: Top-down surveyor projection.");
      }
    }

export function reset3DCamera() {
      set3DCameraPreset('overview');
    }

